
class ProductForm extends HTMLElement {
  constructor() {
    super();

    this.form = this.querySelector('form');
    if (!this.form) return;

    this.form.addEventListener('submit', this.onSubmit.bind(this));

    this.cart = document.querySelector('cart-drawer');
    
    this.submitButton = this.querySelector('[type="submit"]');
    this.submitButtonText = this.submitButton.querySelector('span');
    this.spinner = this.querySelector('.loading__spinner');

    if (this.cart) this.submitButton.setAttribute('aria-haspopup', 'dialog');

    this.hideErrors = this.dataset.hideErrors === 'true';
  }

  onSubmit(event) {
    event.preventDefault();
    if (this.submitButton.disabled) return;
    if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

    this.submitButton.setAttribute('disabled', 'disabled');
    this.submitButton.setAttribute('aria-disabled', 'true');
    this.submitButtonText.style.opacity = 0;
    this.submitButton.classList.add('loading');
    this.spinner.classList.remove('hidden');

    const formData = new FormData(this.form);
    if (this.cart) {
      formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
      formData.append('sections_url', window.location.pathname);
      this.cart.setActiveElement(document.activeElement);
    }

    fetch('/cart/add.js', {
      method: 'POST',
      body: formData,
      headers: { 'X-Requested-With': 'XMLHttpRequest' }
    })
    .then((response) => response.json())
    .then((response) => {
      if (response.status) {
        publish(PUB_SUB_EVENTS.cartError, { source: 'product-form', response: response });
        this.submitButtonText.textContent = 'Sold out';
        this.errors = true;
        return;
      } else if (!this.cart) {
        window.location = window.routes.cart_url;
        return;
      }

      this.errors = false;

      publish(PUB_SUB_EVENTS.cartUpdate, {
        source: 'product-form',
        //productVariantId: formData.get('id'),
        cartData: response
      });
      this.cart.renderContents(response);
    })
    .catch((error) => {
      console.error(error);
    })
    .finally(() => {
      if (!this.errors) {
        this.submitButton.setAttribute('aria-disabled', 'false');
        this.submitButton.removeAttribute('disabled');
      }
      this.submitButtonText.style.opacity = 1;
      this.submitButton.classList.remove('loading');
      this.spinner?.classList.add('hidden');
    });
  }
}

customElements.define('product-form', ProductForm);